import { render, staticRenderFns } from "./TracksReleasesEditPanelDialog.vue?vue&type=template&id=12c99fe9"
import script from "./TracksReleasesEditPanelDialog.vue?vue&type=script&lang=js"
export * from "./TracksReleasesEditPanelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports